import { Navigate, useLocation } from "react-router-dom"
import { intersection } from "lodash"
import { useAuthUser } from "../hooks/useAuth"
import { isFullScope, isTwoFaScope } from "../constants"
import routePaths from "../constants/path"
import { getLandingPath } from "../routes"
import FullPageLoader from "./FullPageLoader"
import Forbidden from "./Forbidden"

const ProtectedRoute = ({ component, whoCanAccess }) => {
  const { data, isLoading, isError } = useAuthUser()
  const location = useLocation()

  if (isLoading) return <FullPageLoader />
  if (isError || !data) return <Navigate replace to={routePaths.login} />

  if (isTwoFaScope(data.scope)) {
    return data.twoFAEnabled ? (
      <Navigate replace to={routePaths.verifyTwoFa} />
    ) : (
      <Navigate replace to={routePaths.enableTwoFa} />
    )
  }

  if (!isFullScope(data.scope)) {
    return <Navigate replace to={routePaths.login} />
  }

  const user = data.data
  if (whoCanAccess && intersection(whoCanAccess, user?.role).length === 0) {
    // The homepage is not accessible to every role, so send those roles to
    // the first page they can actually open instead of a dead 403
    const landingPath = getLandingPath(user?.role)
    if (
      location.pathname === routePaths.homepage &&
      landingPath !== routePaths.homepage
    ) {
      return <Navigate replace to={landingPath} />
    }
    return <Forbidden />
  }

  return <>{component}</>
}

export default ProtectedRoute
